// extracted by mini-css-extract-plugin
export var alertIcon = "_rz-0";